import React,{useState} from "react";
import "./contact.css";

import Aeroplane from "../animations/aeroplane.json";
import Lottie from "lottie-react";

import emailjs from 'emailjs-com';

function Contact(){

  const [statusMessage, setStatusMessage] = useState("Submit")

  // code that helps in recieving emails
  function sendEmail(e) {
    e.preventDefault(); //doesnt refreshes the screen

    emailjs.sendForm('service_ruwm256', 'template_bl37bxc', e.target, '1QwtD9l2ocCsWt4mz')
      .then((result) => {
          console.log("success");
          setStatusMessage("Sent");
          const timer = setTimeout(()=>{
              setStatusMessage("Submit");
          },3000);
      }, (error) => {
          console.log(error.text);
      });
  }


  return(
    <div id="Contact">
          <div className="contact-div">
                <div className="contact-details" data-aos="fade-right" data-aos-duration="600" data-aos-delay="100">
                      <div className="contact-me">
                          <h2 className="contact-me-h2"><span className="contact-me-span">CONTACT</span> ME</h2>
                      </div>
                      <div className="contact-email">
                          <a className="contact-email-a" href="mailto::akshatsinghchouhan16@gmail.com">akshatsinghchouhan16@gmail.com</a>
                      </div>
                      <div className="contact-phone">
                          <a className="contact-phone-a" target="_blank" href="http://wa.me/+9406602302">+91 9406602302</a>
                      </div>
                      <div className="contact-animation">
                          <Lottie animationData={Aeroplane}/>
                      </div>

                </div>

                <div className="contact-form" data-aos="fade-right" data-aos-duration="600" data-aos-delay="400">
                      <form onSubmit={sendEmail}>
                          <div>
                              <label className="form-label">Name</label>
                              <input className="form-input" autocomplete="none" required type="text" name="from_name" placeholder="Enter Your Name"/>
                          </div>
                          <div class="form-email-div">
                              <label className="form-label">Email</label>
                              <input className="form-input" autocomplete="none" required type="email" name="from_email" placeholder="Enter Your Email Address"/>
                          </div>
                          <div class="form-textarea-div">
                              <label className="form-label">Message</label>
                              <textarea className="form-textarea" name="message" required placeholder="Enter Your Message" ></textarea>
                          </div>
                          <div class="form-button-div">
                              <button className="form-button" type="submit" value="Send">{statusMessage}</button>
                          </div>
                      </form>

                </div>


          </div>


    </div>
  );
}

export default Contact;
